// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimelineCanvas_axisHost__O6UpJ {
  position: relative;
  background: #fff;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  flex: 1 1; /* занимает всё оставшееся место */
}

.TimelineCanvas_axisHost__O6UpJ.TimelineCanvas_dragging__OzrHM {
  cursor: grabbing;
}

/* Верхняя шкала времени */
.TimelineCanvas_ticksRowLocal__2JmhY {
  position: relative;
  height: 26px;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
  z-index: 5;
}

.TimelineCanvas_tickLocal__XXgFH {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  text-align: center;
  white-space: nowrap;
}

.TimelineCanvas_tickLabel__MulxV {
  font-size: 0.7rem;
  color: #666;
  background: #fff;
  padding: 0 2px;
}

.TimelineCanvas_vlineLocal__T74tw {
  position: absolute;
  top: 20px;
  left: 50%;
  width: 1px;
  height: calc(100% - 20px);
  background: rgba(210, 215, 220, 0.7);
}

/* Контейнер строк */
.TimelineCanvas_timelineExpanded__Isyh2 {
  position: relative;
  z-index: 10;
}

.TimelineCanvas_row__8h0rP,
.TimelineCanvas_recRow__VLy0j {
  display: flex;
  align-items: center;
  height: 21px;
  margin: 0;
  border-bottom: 1px solid #f2f4f7;
}

.TimelineCanvas_recRow__VLy0j:hover {
  background: #f9fafb;
}

.TimelineCanvas_activeRow__NpMCo {
  background: rgba(59, 130, 246, 0.05);
}

.TimelineCanvas_rowTrack__BlGib {
  position: relative;
  flex: 1 1;
  height: 8px;
  border-radius: 4px;
}

/* уровни */
.TimelineCanvas_levelTravel__Cdihk {
  position: absolute;
  top: -3px;
  height: 3px;
  border-radius: 2px;
  background: #a855f7;
  opacity: 0.6;
  z-index: 1;
}

.TimelineCanvas_levelStop__uz2ga {
  position: absolute;
  top: 3px;
  height: 3px;
  border-radius: 3px;
  background: rgba(245, 158, 11, 0.85);
  z-index: 6;
}

.TimelineCanvas_levelMain__ggG6c {
  position: absolute;
  top: 1px;
  height: 6px;
  border-radius: 3px;
  z-index: 3;
  transition: box-shadow 0.2s ease;
}

.TimelineCanvas_dot__VH6px {
  position: absolute;
  top: 0px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  transform: translate(-50%, -1px);
  z-index: 4;
}

.TimelineCanvas_activeRow__NpMCo .TimelineCanvas_dot__VH6px {
  outline: 2px solid rgba(59, 130, 246, 0.7);
  outline-offset: 1px;
}

.TimelineCanvas_activeRow__NpMCo .TimelineCanvas_levelMain__ggG6c {
  box-shadow: 0 0 5px 2px rgba(59, 130, 246, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/Routes/modal/timeline/TimelineCanvas.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,SAAO,EAAE,kCAAkC;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,WAAW;EACX,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".axisHost {\r\n  position: relative;\r\n  background: #fff;\r\n  cursor: grab;\r\n  user-select: none;\r\n  flex: 1; /* занимает всё оставшееся место */\r\n}\r\n\r\n.axisHost.dragging {\r\n  cursor: grabbing;\r\n}\r\n\r\n/* Верхняя шкала времени */\r\n.ticksRowLocal {\r\n  position: relative;\r\n  height: 26px;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  background: #fff;\r\n  z-index: 5;\r\n}\r\n\r\n.tickLocal {\r\n  position: absolute;\r\n  top: 0;\r\n  transform: translateX(-50%);\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.tickLabel {\r\n  font-size: 0.7rem;\r\n  color: #666;\r\n  background: #fff;\r\n  padding: 0 2px;\r\n}\r\n\r\n.vlineLocal {\r\n  position: absolute;\r\n  top: 20px;\r\n  left: 50%;\r\n  width: 1px;\r\n  height: calc(100% - 20px);\r\n  background: rgba(210, 215, 220, 0.7);\r\n}\r\n\r\n/* Контейнер строк */\r\n.timelineExpanded {\r\n  position: relative;\r\n  z-index: 10;\r\n}\r\n\r\n.row,\r\n.recRow {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 21px;\r\n  margin: 0;\r\n  border-bottom: 1px solid #f2f4f7;\r\n}\r\n\r\n.recRow:hover {\r\n  background: #f9fafb;\r\n}\r\n\r\n.activeRow {\r\n  background: rgba(59, 130, 246, 0.05);\r\n}\r\n\r\n.rowTrack {\r\n  position: relative;\r\n  flex: 1;\r\n  height: 8px;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* уровни */\r\n.levelTravel {\r\n  position: absolute;\r\n  top: -3px;\r\n  height: 3px;\r\n  border-radius: 2px;\r\n  background: #a855f7;\r\n  opacity: 0.6;\r\n  z-index: 1;\r\n}\r\n\r\n.levelStop {\r\n  position: absolute;\r\n  top: 3px;\r\n  height: 3px;\r\n  border-radius: 3px;\r\n  background: rgba(245, 158, 11, 0.85);\r\n  z-index: 6;\r\n}\r\n\r\n.levelMain {\r\n  position: absolute;\r\n  top: 1px;\r\n  height: 6px;\r\n  border-radius: 3px;\r\n  z-index: 3;\r\n  transition: box-shadow 0.2s ease;\r\n}\r\n\r\n.dot {\r\n  position: absolute;\r\n  top: 0px;\r\n  width: 9px;\r\n  height: 9px;\r\n  border-radius: 50%;\r\n  transform: translate(-50%, -1px);\r\n  z-index: 4;\r\n}\r\n\r\n.activeRow .dot {\r\n  outline: 2px solid rgba(59, 130, 246, 0.7);\r\n  outline-offset: 1px;\r\n}\r\n\r\n.activeRow .levelMain {\r\n  box-shadow: 0 0 5px 2px rgba(59, 130, 246, 0.3);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"axisHost": `TimelineCanvas_axisHost__O6UpJ`,
	"dragging": `TimelineCanvas_dragging__OzrHM`,
	"ticksRowLocal": `TimelineCanvas_ticksRowLocal__2JmhY`,
	"tickLocal": `TimelineCanvas_tickLocal__XXgFH`,
	"tickLabel": `TimelineCanvas_tickLabel__MulxV`,
	"vlineLocal": `TimelineCanvas_vlineLocal__T74tw`,
	"timelineExpanded": `TimelineCanvas_timelineExpanded__Isyh2`,
	"row": `TimelineCanvas_row__8h0rP`,
	"recRow": `TimelineCanvas_recRow__VLy0j`,
	"activeRow": `TimelineCanvas_activeRow__NpMCo`,
	"rowTrack": `TimelineCanvas_rowTrack__BlGib`,
	"levelTravel": `TimelineCanvas_levelTravel__Cdihk`,
	"levelStop": `TimelineCanvas_levelStop__uz2ga`,
	"levelMain": `TimelineCanvas_levelMain__ggG6c`,
	"dot": `TimelineCanvas_dot__VH6px`
};
export default ___CSS_LOADER_EXPORT___;
